import React from "react";

const badgeColor = {
  earned_question: "bg-green-100 text-green-700",
  earned_contest: "bg-green-100 text-green-700",
  earned_referral: "bg-green-100 text-green-700",
  earned_referral_bonus: "bg-green-100 text-green-700",

  recharge: "bg-blue-100 text-blue-700",

  spent_question: "bg-red-100 text-red-700",
  spent_contest: "bg-red-100 text-red-700",
  spent_plan: "bg-red-100 text-red-700",

  refund: "bg-yellow-100 text-yellow-700",
  contest_refund: "bg-yellow-100 text-yellow-700",

  withdrawn: "bg-gray-100 text-gray-700",
};

export default function TransactionTable({
  transactions = [],
  page = 1,
  limit = 25,
}) {
  return (
    <div className="hidden lg:block bg-white rounded-xl shadow overflow-hidden">
      <table className="w-full">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-4 text-left">#</th>
            <th className="p-4 text-left">User</th>
            <th className="p-4 text-left">Mobile</th>
            <th className="p-4 text-left">Type</th>
            <th className="p-4 text-left">Amount</th>
            <th className="p-4 text-left">Balance</th>
            <th className="p-4 text-left">Date</th>
            <th className="p-4 text-left">Description</th>
          </tr>
        </thead>

        <tbody>
          {transactions.length === 0 ? (
            <tr>
              <td
                colSpan={8}
                className="text-center py-10 text-gray-500"
              >
                No Transactions Found
              </td>
            </tr>
          ) : (
            transactions.map((item, index) => (
              <tr
                key={item._id}
                className="border-b hover:bg-gray-50 transition"
              >
                <td className="p-4 font-semibold">
                  {(page - 1) * limit + index + 1}
                </td>

                <td className="p-4 font-medium">
                  {item.user?.name || "-"}
                </td>

                <td className="p-4 text-gray-600">
                  {item.user?.mobile || "-"}
                </td>

                <td className="p-4">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold ${
                      badgeColor[item.type] ||
                      "bg-gray-100 text-gray-700"
                    }`}
                  >
                    {item.type?.replaceAll("_", " ")}
                  </span>
                </td>

                <td className="p-4 font-semibold">
                  {Number(item.amount || 0).toLocaleString()}
                </td>

                <td className="p-4">
                  {item.balanceBefore} → {item.balanceAfter}
                </td>

                <td className="p-4 whitespace-nowrap">
                  {new Date(item.createdOn).toLocaleString()}
                </td>

                <td className="p-4">
                  {item.description || "-"}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}